import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Search from "../../assets/images/search.svg";

function SearchableDD({ entries, active, updateFilterValue, selectedInps, placeholder, filterName, showID, diffInp }) {
  const [mainEntries, setMainEntries] = useState([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setMainEntries(entries)
  }, [entries])

  const entriesSearch = (value) => {
    setMainEntries(
      entries.filter(entry => (translate(
        entry.name ? entry.name 
        : entry.value ? entry.value 
        : entry.label ? entry.label 
        : entry
      )).toLowerCase().includes(value.toLowerCase()))
    )
  }

  const translate = (value) => {
    if(value.title_de && value.title_en) {
      return value['title_' + i18n.language]
    }

    if(value.includes("[[")) {
      let arr = value.split(' ')
      let translatedText = '';
      arr.forEach(text => {
        if(text.includes("[[")) {
          translatedText += t('fabric_compositions.' + text) + ' '
        } else {
          translatedText += text + ' '
        }
      });
      return translatedText
    }

    return t(value);
  }

  return (
    <div className={"family-panel " + (active ? "active" : "")}>
      <div className="search">
        <img src={Search} alt="" />
        <input type="text" placeholder={t(placeholder)} onChange={e => entriesSearch(e.target.value)} />
      </div>
      <div className="result-list">
        <div className="ff-list">
          {mainEntries?.length ? mainEntries?.map((entry, key) =>
            <div className="entry" key={key}>
              <input id={(entry.title_de ? entry.title_de : entry.name ? entry.name : entry.value ? entry.value : entry + (entry.id ? entry.id : entry)) + diffInp} type="checkbox" value={(entry.id ? entry.id : entry)} onChange={() => updateFilterValue(filterName, (entry.id ? entry.id : entry))} checked={selectedInps.includes((entry.id ? entry.id : entry))} />
              <label htmlFor={(entry.title_de ? entry.title_de : entry.name ? entry.name : entry.value ? entry.value : entry + (entry.id ? entry.id : entry)) + diffInp} className="details">
                <p className="label">{showID ? (entry.id ? entry.id : entry) + " - " : ""}{translate(entry.name ? entry.name : entry.value ? entry.value : entry.label ? entry.label : entry)}</p>
                <div className="preview">
                  <p className="is-selected">{t('filters.selected')}</p>
                </div>
              </label>
            </div>
          ) : (
            <div className="no-options">
              <p>{t('filters.no_display_option')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchableDD